
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/school/course/[coursePath]",
      function () {
        return require("private-next-pages/school/course/[coursePath]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/school/course/[coursePath]"])
      });
    }
  